import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="admin-panel">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner sliding">
        <div class="left">
          <a href="#" class="link back">
            <i class="icon icon-back"></i>
            <span class="if-not-md">Back</span>
          </a>
        </div>
        <div class="title">${locale.translate('admin.title')}</div>
      </div>
    </div>
    <div class="page-content">
      <div class="block stack-content text-align-center center-content">
        <div class="card sub-item">
          <div class="sub-header text-align-center">${locale.translate('admin.sections.carPricing')}</div>
          <div class="card-content card-content-padding">
            <div class="item-media">
              <i class="icon material-symbols-outlined">euro</i>
            </div>
            <div class="card-footer justify-content-center">
              <a class="button button-small button-fill" href="/car-pricing-dashboard/">
                <i class="icon material-symbols-outlined">wallet</i> ${locale.translate('general.go')}
              </a>
            </div>
          </div>
        </div>
        <div class="card sub-item">
          <div class="sub-header text-align-center">${locale.translate('admin.sections.carLoanGrid')}</div>
          <div class="card-content card-content-padding">
            <div class="item-media">
              <i class="icon material-symbols-outlined">list_alt</i>
            </div>
            <div class="card-footer justify-content-center">
              <a class="button button-small button-fill" href="/car-loan-list/">
                <i class="icon material-symbols-outlined">list_alt</i> ${locale.translate('general.go')}
              </a>
            </div>
          </div>
        </div>
        <div class="card sub-item">
          <div class="sub-header text-align-center">${locale.translate('admin.sections.buyoutDeposit.adminButton')}</div>
          <div class="card-content card-content-padding">
            <div class="item-media">
              <i class="icon material-symbols-outlined">credit_score</i>
            </div>
            <div class="card-footer justify-content-center">
              <a class="button button-small button-fill" href="/car-buyout-deposit-dashboard/">
                <i class="icon material-symbols-outlined">credit_score</i> ${locale.translate('general.go')}
              </a>
            </div>
          </div>
        </div>
        <div class="card sub-item">
          <div class="sub-header text-align-center">${locale.translate('admin.sections.refund.adminButton')}</div>
          <div class="card-content card-content-padding">
            <div class="item-media">
              <i class="icon material-symbols-outlined">request_page</i>
            </div>
            <div class="card-footer justify-content-center">
              <a class="button button-small button-fill" href="/car-loan-issue-dashboard/">
                <i class="icon material-symbols-outlined">request_page</i> ${locale.translate('general.go')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
`
    }
    ;
}
framework7Component.id = '5d274e1f11';
export default framework7Component;